import React, { Suspense, useEffect } from 'react';
// Lazy loading example
// import React, { Suspense, lazy } from 'react'; 
import { Routes, Route, useLocation } from 'react-router-dom';
import Header from './components/Header';
import ScrollToHash from './components/ScrollToHash';
import Jumbotron from './components/Jumbotron/Jumbotron';
import About from './components/About/About';
import Contact from './components/Contact/Contact';
import ContactPage from './components/Contact/ContactPage';
import Projects from './components/Projects/Projects';
import ProjectsPage from './components/Projects/ProjectsPage';
import ProjectDetail from './components/Projects/ProjectDetail';
import NotFound from './components/NotFound/NotFound';
import Footer from './components/Footer/Footer';

function App() {
  const location = useLocation();

  useEffect(() => {
    if (location.pathname === '/') {
      document.title = 'Kayleigh Schlupp — Full Stack Developer (UX/UI)';
    }
  }, [location.pathname]);
  return (
    <div className="App">
      {/* Skip link for keyboard users */}
      <a href="#main" className="skip-link">Skip to main content</a>
      <Header />
      <ScrollToHash />
      <main id="main" role="main">
        <Suspense fallback={<div>Loading...</div>}>
          <Routes>
            <Route path="/" element={
              <>
                <Jumbotron />
                <About />
                <Projects />
                <Contact />
              </>
            } />
            <Route path="/projects" element={<ProjectsPage />} />
            <Route path="/projects/:slug" element={<ProjectDetail />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
      </main>
      <Footer />
    </div>
  );
}

export default App;